import { HttpErrorResponse, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { Injector } from '@angular/core';
import { IdentityOptions } from '../types/internal-types';
import { AccessToken } from '../types/global-types';

export class RequestHelper {
  static options?: IdentityOptions;

  static isIdentityEndpointRequest(request: HttpRequest<unknown>): boolean {
    return (
      (!!this.options?.backendUrl && request.url.startsWith(this.options?.backendUrl)) ||
      (!!this.options?.frontendUrl && request.url.startsWith(this.options?.frontendUrl))
    );
  }

  static isAuthorizedRequest(request: HttpRequest<unknown>): boolean {
    return !this.options?.requestFilter || this.options.requestFilter(request);
  }

  static isAuthorizationError(error: unknown): boolean {
    return error instanceof HttpErrorResponse && error.status === 401;
  }

  static attachAuthorizationHeader(request: HttpRequest<unknown>, accessToken: AccessToken): HttpRequest<unknown> {
    return request.clone({
      setHeaders: { authorization: `Bearer ${accessToken.token}`, 'auth-source': 'IDMS' },
    });
  }

  static onAuthorizationError(error: unknown, injector: Injector):Observable<never> {

    if (this.options?.onAuthorizationError) {
      this.options?.onAuthorizationError(error, injector);

	  if(error instanceof Object) {
		  error['isAuthorizationError'] = true;
	  }

    }

    return throwError(error);
  }
}
